import { createSelector } from 'reselect';
import { countBy, flatten, flow, map } from 'lodash/fp';

import playerPositionsSelector from './playerPositionsSelector';

const selectedPlayersSelector = createSelector(
  playerPositionsSelector,
  flow(
    map('selections'),
    flatten
  )
);

const selectionsByGameSelector = createSelector(
  selectedPlayersSelector,
  countBy('gameId')
);

export default selectionsByGameSelector;
